import React from 'react';
import { X, Check, Sparkles, Gift, Tag, ShieldCheck, ArrowRight } from 'lucide-react';
interface UpsellModalProps {
  isOpen: boolean;
  onClose: () => void;
  baseCheckoutUrl: string;
  discountCheckoutUrl: string;
}
export function UpsellModal({
  isOpen,
  onClose,
  baseCheckoutUrl,
  discountCheckoutUrl
}: UpsellModalProps) {
  if (!isOpen) return null;
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose();
  };
  const trackCheckout = (value: number, items: number) => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: '30 Recetas Anti-Inflamatorias para Mascotas',
        content_category: 'E-book',
        value,
        currency: 'COP',
        num_items: items
      });
    }
  };
  return <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" onClick={handleBackdropClick} style={{
    backgroundColor: 'rgba(0,0,0,0.6)',
    backdropFilter: 'blur(4px)'
  }} data-id="element-1296">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full max-h-[85vh] overflow-y-auto relative" style={{
      animation: 'modalSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
    }} data-id="element-1297">
        <style data-id="element-1298">{`
          @keyframes modalSlideIn {
            from { opacity: 0; transform: scale(0.95) translateY(10px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
          }
        `}</style>

        {/* Close button */}
        <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors" data-id="element-1299">
          <X className="w-4 h-4 text-gray-600" data-id="element-1300" />
        </button>

        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 via-red-500 to-orange-500 p-3 rounded-t-2xl text-center relative overflow-hidden" data-id="element-1301">
          <div className="absolute top-0 left-0 w-24 h-24 bg-white/10 rounded-full blur-2xl -translate-x-1/2 -translate-y-1/2" data-id="element-1302"></div>
          <div className="absolute bottom-0 right-0 w-20 h-20 bg-yellow-300/15 rounded-full blur-2xl translate-x-1/2 translate-y-1/2" data-id="element-1303"></div>
          <div className="relative z-10" data-id="element-1304">
            <div className="inline-flex items-center gap-1.5 bg-yellow-400 text-red-900 px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider mb-2" data-id="element-1305">
              <Sparkles className="w-3 h-3" data-id="element-1306" />
              ¡Espera! Oferta exclusiva
            </div>
            <h3 className="text-lg font-extrabold text-white leading-tight" data-id="element-1307">
              🔥 Llévate TODO con un
              <br data-id="element-1308" />
              <span className="text-yellow-300 text-xl" data-id="element-1309">30% DE DESCUENTO</span>
            </h3>
          </div>
        </div>

        {/* Content */}
        <div className="p-3" data-id="element-1310">
          <p className="text-xs text-gray-600 text-center mb-3 leading-relaxed" data-id="element-1311">
            Antes de irte solo con el e-book, mira lo que puedes llevarte{' '}
            <strong data-id="element-1312">por mucho menos</strong>:
          </p>

          {/* What's included */}
          <div className="bg-gradient-to-br from-orange-50 to-yellow-50 p-3 rounded-xl border border-orange-200 mb-3" data-id="element-1313">
            <div className="flex gap-3 items-start" data-id="element-1314">
              <img src="https://cdn.magicpatterns.com/uploads/1BbTjWu8cy6esJFPwLvaXu/ChatGPT_Image_10_feb_2026,_10_47_56_p.m..png" alt="Paquete completo con descuento" className="w-20 h-auto rounded-lg border border-orange-200 shadow-sm flex-shrink-0" data-id="element-1315" />
              <div className="flex-1 min-w-0" data-id="element-1316">
                <p className="text-[10px] font-bold text-gray-800 mb-1.5 flex items-center gap-1" data-id="element-1317">
                  <Gift className="w-3 h-3 text-orange-600" data-id="element-1318" />
                  El paquete completo incluye:
                </p>
                <div className="space-y-1" data-id="element-1319">
                  <div className="flex items-start gap-1.5" data-id="element-1320">
                    <Check className="w-3 h-3 text-orange-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-1321" />
                    <span className="text-[10px] text-gray-700 leading-tight" data-id="element-1322">
                      📖 <strong data-id="element-1323">30 Recetas Naturales</strong> + 3 Regalos
                      Gratis
                    </span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-1324">
                    <Check className="w-3 h-3 text-teal-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-1325" />
                    <span className="text-[10px] text-gray-700 leading-tight" data-id="element-1326">
                      🛒 <strong data-id="element-1327">Compra bien</strong> — Ingredientes económicos
                      + sustituciones
                    </span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-1328">
                    <Check className="w-3 h-3 text-amber-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-1329" />
                    <span className="text-[10px] text-gray-700 leading-tight" data-id="element-1330">
                      🍳 <strong data-id="element-1331">Cocina 1 vez por semana</strong> — Sistema
                      semanal + audioguía
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Price comparison */}
          <div className="bg-white border-2 border-green-200 rounded-xl p-3 mb-3 text-center" data-id="element-1332">
            <div className="flex items-center justify-center gap-3 mb-1.5" data-id="element-1333">
              <div data-id="element-1334">
                <span className="text-[10px] text-gray-500 block" data-id="element-1335">
                  Precio normal
                </span>
                <span className="text-base text-gray-400 line-through font-bold" data-id="element-1336">
                  $55.999
                </span>
              </div>
              <ArrowRight className="w-4 h-4 text-green-500" data-id="element-1337" />
              <div data-id="element-1338">
                <span className="text-[10px] text-green-600 font-bold block" data-id="element-1339">
                  HOY con 30% OFF
                </span>
                <span className="text-xl text-green-600 font-extrabold" data-id="element-1340">
                  $39.199
                </span>
              </div>
            </div>
            <div className="inline-flex items-center gap-1 bg-green-100 text-green-700 px-2.5 py-0.5 rounded-full text-[10px] font-bold" data-id="element-1341">
              <Tag className="w-3 h-3" data-id="element-1342" />
              Ahorras $16.800 COP
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="space-y-2" data-id="element-1343">
            <a href={discountCheckoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" onClick={() => trackCheckout(39199, 3)} data-id="element-1344">
              <button className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-3 px-4 rounded-xl shadow-lg shadow-green-200 transition-all duration-200 hover:-translate-y-0.5 flex flex-col items-center justify-center gap-0.5 text-center relative overflow-hidden" data-id="element-1345">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent -translate-x-full animate-[shimmer_2s_infinite]" data-id="element-1346"></div>
                <span className="text-sm leading-tight flex items-center gap-1.5 relative z-10" data-id="element-1347">
                  <Sparkles className="w-3.5 h-3.5 text-yellow-300" data-id="element-1348" />
                  COMPRAR CON 30% DE DESCUENTO
                </span>
                <span className="text-[10px] opacity-90 relative z-10" data-id="element-1349">
                  <span className="line-through opacity-70" data-id="element-1350">$55.999</span> →{' '}
                  <strong data-id="element-1351">$39.199 COP</strong>
                </span>
              </button>
            </a>

            <a href={baseCheckoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" onClick={() => trackCheckout(19999, 1)} data-id="element-1352">
              <button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-2.5 px-4 rounded-xl border border-orange-600 transition-all duration-200 text-[10px] text-center uppercase tracking-wide leading-tight" data-id="element-1353">
                NO GRACIAS, SOLO QUIERO EL E-BOOK PRINCIPAL — $19.999 COP
              </button>
            </a>
          </div>

          {/* Trust badge */}
          <div className="mt-3 flex items-center justify-center gap-1.5 text-[10px] text-gray-400" data-id="element-1354">
            <ShieldCheck className="w-3 h-3" data-id="element-1355" />
            <span data-id="element-1356">Garantía de 7 días • Pago seguro • Acceso inmediato</span>
          </div>
        </div>
      </div>
    </div>;
}